// @flow

import ApiClient from 'utils/ApiClient';
import Dispatcher from 'dispatcher';
import { LOAD_SCREENING_PARAMS } from 'modules/dashboards/api/action_types/ScreeningParamsActionTypes';
import { SCREENING_PARAMS } from 'utils/Constants';

class ScreeningParamsActions {
  getDegreeLevels = () =>
    this._getScreeningParams(SCREENING_PARAMS.degreeLevels);

  getSeniorityYears = () =>
    this._getScreeningParams(SCREENING_PARAMS.seniorityYears);

  getPositionTypes = () =>
    this._getScreeningParams(SCREENING_PARAMS.positionTypes);

  getRelationShipMoral = () =>
    this._getScreeningParams(SCREENING_PARAMS.Relationship_moral);

  getRelationShipPhysical = () =>
    this._getScreeningParams(SCREENING_PARAMS.Relationship_physical);

  getEnterpriseTypes = () =>
    this._getScreeningParams(SCREENING_PARAMS.enterpriseTypes);

  getEnterpriseSize = () =>
    this._getScreeningParams(SCREENING_PARAMS.EnterpriseSizes);

  getNumberOfBranches = () =>
    this._getScreeningParams(SCREENING_PARAMS.NumberBranches);

  _getScreeningParams = (name: string) =>
    ApiClient.get({
      path: `/screening_params?name=${name}`
    }).then(response =>
      Dispatcher.dispatch({
        type: LOAD_SCREENING_PARAMS,
        screeningParams: response,
        name: name
      })
    );
}

export default new ScreeningParamsActions();
